module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("现场照片")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11 flexbox"
  }, [_vm._l((_vm.photos), function(picName, index) {
    return _c('div', {
      key: index,
      staticClass: "live_photo",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getMaxPic($event, picName)
        }
      }
    }, [(picName.photoStatus == 2) ? _c('a', {
      staticClass: "thumbnail"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + _vm.picUrl2 + picName.logourl + ')',
        backgroundSize: 'cover',
        height: '100px',
        width: '100px'
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPhotoStatus(picName.photoStatus)))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.potShow),
        expression: "potShow"
      }],
      staticClass: "el-icon-circle-close closebtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletePhoto(picName.id)
        }
      }
    })]) : _c('a', {
      staticClass: "thumbnail"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + (picName.logourl.indexOf('http') !== -1 ? picName.logourl : _vm.picUrl + picName.logourl) + ')',
        backgroundSize: 'cover',
        height: '100px',
        width: '100px'
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPhotoStatus(picName.photoStatus)))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.potShow),
        expression: "potShow"
      }],
      staticClass: "el-icon-circle-close closebtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletePhoto(picName.id)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.potShow),
      expression: "potShow"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addPhotos
    }
  }, [_vm._v("现场照片")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "现场照片",
      "closeOnClickModal": false,
      "modal-append-to-body": false,
      "visible": _vm.photosVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.photosVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "photosBox"
  }, [_c('el-form', {
    ref: "photoform",
    staticClass: "demo-ruleForm",
    attrs: {
      "rules": _vm.photorules,
      "model": _vm.photoform,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "照片类型",
      "prop": "choseValue"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.photoform.choseValue),
      callback: function($$v) {
        _vm.$set(_vm.photoform, "choseValue", $$v)
      },
      expression: "photoform.choseValue"
    }
  }, _vm._l((_vm.choseophotos), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现场照片",
      "prop": "photoImages"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "list-type": "picture-card",
      "action": _vm.photopicUrl,
      "headers": {
        'access-token': this.accesstoken
      },
      "on-preview": _vm.photoPreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.photosSuccess,
      "on-exceed": _vm.handleExceed,
      "before-upload": _vm.beforeupload,
      "file-list": _vm.photoslist
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过400k")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.photosVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confimbtn('photoform')
      }
    }
  }, [_vm._v("确定")])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": true,
      "modal-append-to-body": false,
      "visible": _vm.photoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.photoVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.photoImageUrl,
      "alt": ""
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb88b02a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RescueOrderPics.vue
// module id = 1657
// module chunks = 0